export enum Page {
  PaymentOrderPage = 'payment-order',
  eIRAPage = 'e-ira',
  PartiesPage = 'parties',
  DirectDebitPage = 'direct-debit',
}
